/*
 * @LastEditors: wangyingying162
 * @LastEditTime: 2022-09-06 16:47:19
 * @Author: wangyingying162
 */
import {
  CardTypeEnum,
  BankInfoOfCardNo,
  SupportBankCard,
  SendSmsOrBindCardResult,
} from '@/api/bank-card/types';

import { ContractItem } from '@/ContractConfig';

export interface StateType {
  // 持卡人姓名
  userName: string;

  // 银行卡号 以及是否需要掩码（脱敏）现实银行卡号
  cardNo: string;
  defaultCardNo: string;
  shouldMaskCardNo: boolean;

  // 银行名称 银行卡类型
  bankInfo: BankInfoOfCardNo | undefined;
  // 银行卡号所属银行是否被支持: false 不支持 / true 支持 / undefined 数据未获取完全
  isBankSupported: boolean | undefined;

  // 预留手机号码（系统中默认的手机号码）以及是否需要掩码显示手机号码
  reservePhone: string;
  defaultReservePhone: string;
  shouldMaskPhoneNo: boolean;

  // 实名身份证号，以及是否需要掩码显示手机号码
  idCardNo: string;

  // 短信验证码
  smsCode: string;

  // 支持的银行卡列表
  supportList: SupportBankCard[];

  // 协议列表
  contractList: ContractItem[];

  // 短信验证码发送时间以及发送（或绑定）结果
  sendSmsTimeStamp: number;
  sendSmsOrBindCardResult: SendSmsOrBindCardResult | undefined;
  historyLength: number | undefined,
}

export const CardTypeNameOptions = {
  [CardTypeEnum.DebitCard]: '储蓄卡',
  [CardTypeEnum.CreditCard]: '信用卡',
};

export interface BackQuickBindContext {
  historyLength: number;
  bankInfo: {
    bankName: string,
    bankLogo: string,
    cardType: string,
  };
  storeCacheData: Dictionary<string>;
}
